import React from 'react';
import { motion } from 'framer-motion';
import { 
  BarChart3, 
  Target, 
  Users, 
  Gift, 
  User 
} from 'lucide-react';
import { TabType } from '../MobileApp';

interface TabNavigationProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

const tabs = [
  { id: 'dashboard' as TabType, label: 'Impact', icon: BarChart3 },
  { id: 'missions' as TabType, label: 'Missions', icon: Target },
  { id: 'social' as TabType, label: 'Community', icon: Users },
  { id: 'rewards' as TabType, label: 'Rewards', icon: Gift },
  { id: 'profile' as TabType, label: 'Profile', icon: User },
];

export default function TabNavigation({ activeTab, onTabChange }: TabNavigationProps) {
  return (
    <nav className="safe-bottom tab-bar px-2 py-2">
      <div className="flex items-center justify-around">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className="touch-target flex-1 flex flex-col items-center py-2 px-1 relative"
            >
              {/* Active Indicator */}
              {isActive && (
                <motion.div
                  layoutId="activeTab"
                  className="absolute inset-0 bg-emerald-50 rounded-2xl"
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
              )}
              
              {/* Icon */}
              <motion.div
                animate={{
                  scale: isActive ? 1.1 : 1,
                  color: isActive ? '#10B981' : '#6B7280'
                }}
                transition={{ duration: 0.2 }}
                className="relative z-10 mb-1"
              >
                <Icon className="h-6 w-6" />
              </motion.div>
              
              {/* Label */}
              <motion.span
                animate={{
                  color: isActive ? '#10B981' : '#6B7280',
                  fontWeight: isActive ? 600 : 400
                }}
                transition={{ duration: 0.2 }}
                className="text-xs relative z-10"
              >
                {tab.label}
              </motion.span>
              
              {/* Badge for notifications */}
              {tab.id === 'missions' && (
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="absolute -top-1 right-3 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center"
                >
                  <span className="text-xs font-bold text-white">2</span>
                </motion.div>
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}